<template>

<div class="clog-overlay" v-on:click.self="$emit('close')">

	<div class="clog" role="dialog" aria-modal="true" aria-label="Changelog">

		<button class="clog-close" type="button" v-on:click="$emit('close')" aria-label="Close">&times;</button>

		<div class="clog-head">
			<h3 class="clog-title">Changelog</h3>
			<p class="clog-sub">Recent builds and what changed</p>
		</div>

		<div class="clog-body">

			<div class="clog-build" v-for="build in builds" :key="build.version">

				<div class="clog-build-head">
					<span class="clog-build-ver">v{{ build.version }}</span>
					<span class="clog-build-date">{{ build.date }}</span>
					<span class="clog-build-tags">
						<span class="clog-tag is-add" v-if="build.additions">Additions <b>{{ build.additions }}</b></span>
						<span class="clog-tag is-chg" v-if="build.changes">Changes <b>{{ build.changes }}</b></span>
						<span class="clog-tag is-fix" v-if="build.fixes">Fixes <b>{{ build.fixes }}</b></span>
					</span>
				</div>

				<ul class="clog-items">
					<li v-for="(item, index) in build.items" :key="index">{{ item }}</li>
				</ul>

			</div>

		</div>

	</div>

</div>

</template>

<script>

/*
	The changelog modal: recent builds and what changed (version, date,
	additions/changes/fixes tags, bullet items), in boxart's editorial style.
	Self-contained overlay (boxart has no shared dialog). The build list lives in
	service/changelog so the header version chip shares the same source.
*/

import { builds } from '../../service/changelog'

export default {

	data: function() {

		return {
			builds: builds
		}

	},

	created: function() {

		var self = this

		// close on Escape
		this.onKey = function(e) { if (e.key === 'Escape') self.$emit('close') }
		document.addEventListener('keydown', this.onKey)

	},

	beforeDestroy: function() {

		document.removeEventListener('keydown', this.onKey)

	}

}

</script>

<style scoped>

.clog-overlay {
	position: fixed;
	inset: 0;
	z-index: 300;
	background: rgba(28, 26, 22, 0.42);
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 24px 16px;
	overflow-y: auto;
}

/* a tall changelog still centres but stays scrollable (margin:auto avoids the
   flex-overflow top-clipping that align-items:center alone can cause) */
.clog {
	margin: auto;
}

.clog {
	position: relative;
	width: 100%;
	max-width: 480px;
	background: var(--paper);
	border: 1px solid var(--hairline);
	border-radius: 14px;
	box-shadow: 0 24px 60px rgba(40, 34, 24, 0.28);
	padding: 24px;
}

.clog-close {
	position: absolute;
	top: 10px;
	right: 10px;
	z-index: 3;
	width: 44px;
	height: 44px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: none;
	border: none;
	font-size: 28px;
	line-height: 1;
	color: var(--muted-2);
	cursor: pointer;
	border-radius: 8px;
	transition: background 140ms ease, color 140ms ease;
}

.clog-close:hover {
	color: var(--ink);
	background: #f4eee2;
}

.clog-title {
	font-family: var(--font-display);
	font-size: 22px;
	font-weight: 600;
	margin: 0;
	color: var(--ink);
}

.clog-sub {
	margin: 4px 0 0;
	font-family: var(--font-body);
	font-size: 13px;
	color: var(--muted-2);
}

.clog-body {
	margin-top: 18px;
}

.clog-build + .clog-build {
	margin-top: 22px;
	padding-top: 22px;
	border-top: 1px solid var(--hairline);
}

.clog-build-head {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 10px;
}

.clog-build-ver {
	font-family: var(--font-mono);
	font-size: 12px;
	font-weight: 600;
	color: var(--paper);
	background: var(--ink);
	border-radius: 6px;
	padding: 3px 8px;
}

.clog-build-date {
	font-family: var(--font-body);
	font-size: 13px;
	color: var(--muted);
}

.clog-build-tags {
	display: flex;
	gap: 6px;
	margin-left: auto;
}

.clog-tag {
	font-family: var(--font-mono);
	font-size: 9.5px;
	letter-spacing: 0.06em;
	text-transform: uppercase;
	color: var(--muted-2);
	border: 1px solid var(--hairline);
	border-radius: 999px;
	padding: 2px 8px;
	display: inline-flex;
	align-items: center;
	gap: 5px;
}

.clog-tag b {
	color: var(--ink);
}

.clog-tag.is-add b {
	color: var(--correct);
}

.clog-tag.is-fix b {
	color: var(--wrong);
}

.clog-items {
	margin: 14px 0 0;
	padding-left: 20px;
	list-style: disc;
}

.clog-items li {
	font-family: var(--font-body);
	font-size: 14px;
	line-height: 1.5;
	color: var(--ink);
	margin-bottom: 8px;
}

.clog-items li::marker {
	color: var(--muted);
}

.clog-items li:last-child {
	margin-bottom: 0;
}

</style>
